import script from "./FacturasCopec.vue?vue&type=script&setup=true&lang=js"
export * from "./FacturasCopec.vue?vue&type=script&setup=true&lang=js"

import "./FacturasCopec.vue?vue&type=style&index=0&id=25175ee2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25175ee2"]])

export default __exports__